<template>
	<div>
		<!--Modal de informações-->
		<vuestic-modal :show.sync="modal.show" :large="true" ref="smallModal" v-bind:small="false" :cancelClass="'none'"
			okText="Fechar" cancelText="Fechar">
			<div slot="title">Informações</div>

			<div v-show="modal.load">
				<div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
					<div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
						<component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80">
						</component>
					</div>
				</div>
			</div>

			<div v-show="!modal.load">
				<vuestic-tabs :names="['Dados Básicos', 'Financeiro', 'Histórico']" ref="tabs">
					<div slot="Dados Básicos">

                        <div class="row">
                            <div class="col-md-4">
                            <div class="row">
                                <span class="col-12 text-center">
                                <img class="img-profile" height="210" :src="'data:image/jpg;base64, ' + modal.conteudo.photoApp" alt="">
                                </span>
                            </div>
                            </div>
                            <div class="col-md-4">
                            <div class="row mb-3">
                                <span class="col-12 text-center">
                                <strong class="font-weight-bold h5">Nome:</strong>
                                </span>
                                <span class="col-12 text-center mt-3">
                                <div class="card-footer card-personalize text-muted">
                                    {{ modal.conteudo.nome }}
                                </div>
                                </span>
                            </div>
                            <div class="row py-3">
                                <span class="col-12 text-center">
                                <strong class="font-weight-bold h5">CPF:</strong>
                                </span>
                                <span class="col-12 text-center mt-3">
                                <div class="card-footer card-personalize text-muted">
                                    {{ modal.conteudo.cpf }}
                                </div>
                                </span>
                            </div>
                            <div class="row py-3">
                                <span class="col-12 text-center">
                                <strong class="font-weight-bold h5">Renach:</strong>
                                </span>
                                <span class="col-12 text-center mt-3">
                                <div class="card-footer card-personalize text-muted">
                                    {{ modal.conteudo.renach }}
                                </div>
                                </span>
                            </div>
                            </div>
                            <div class="col-md-4">
                            <template v-if="modal.conteudo.tipo_processo">
                                <div class="row mb-3">
                                <span class="col-12 text-center">
                                    <strong class="font-weight-bold h5">Descrição do processo:</strong>
                                </span>
                                <span class="col-12 text-center mt-3">
                                    <div class="card-footer card-personalize text-muted">
                                    {{ modal.conteudo.descricao_processo }}
                                    </div>
                                </span>
                                </div>
                                <div class="row py-3">
                                <span class="col-12 text-center">
                                    <strong class="font-weight-bold h5">Número do processo:</strong>
                                </span>
                                <span class="col-12 text-center mt-3">
                                    <div class="card-footer card-personalize text-muted">
                                    {{ modal.conteudo.tipo_processo }}
                                    </div>
                                </span>
                                </div>
                            </template>
                            <div class="row py-3">
                                <span class="col-12 text-center">
                                <strong class="font-weight-bold h5">Início do Processo:</strong>
                                </span>
                                <span class="col-12 text-center mt-3">
                                <div class="card-footer card-personalize text-muted">
                                    {{ modal.conteudo.inicio_processo }}
                                </div>
                                </span>
                            </div>
                            </div>
                        </div>

						<!-- <div class="row">
							<div class="col-md-3" style="text-align:center;">
								<img v-if="modal.conteudo.renach" width="100" :src="'data:image/jpg;base64, ' + modal.conteudo.photoApp"
									alt="Foto">
							</div>
							<div class="col-md-5 dados">
								<strong class="font-weight-bold">Nome:</strong><br>
								{{ modal.conteudo.nome }}
							</div>
							<div class="col-md-4 dados">
								<strong class="font-weight-bold">CPF:</strong><br>
								<span class="circle badge-success" v-if="modal.conteudo.flg_ativo"></span>
								<span class="circle badge-danger" v-if="!modal.conteudo.flg_ativo"></span>
								{{ modal.conteudo.cpf }}
							</div>
						</div> -->
						<br>

						<!--div class="row">
							<div class="col-md-3">
								<strong class="font-weight-bold">Telefone/Celular:</strong><br>
								{{modal.conteudo.telefone}}
							</div>
							<div class="col-md-4">
								<strong class="font-weight-bold">Data de nascimento:</strong><br>
								{{utils.formatDate(modal.conteudo.data_nascimento, true)}}
							</div>
							<div class="col-md-5">
								<strong class="font-weight-bold">E-mail:</strong><br>
								{{modal.conteudo.email}}
							</div>
						</div-->
					</div>

					<!-- <div slot="Endereço">
						<div v-if="modal.conteudo.endereco_aluno">
							<div class="row">
								<div class="col-md-4">
									<strong class="font-weight-bold">Estado:</strong><br>
									{{modal.conteudo.endereco_aluno.endereco.uf}}
								</div>
								<div class="col-md-4">
									<strong class="font-weight-bold">Cidade:</strong><br>
									{{modal.conteudo.endereco_aluno.endereco.cidade}}
								</div>
								<div class="col-md-4">
									<strong class="font-weight-bold">Bairro:</strong><br>
									{{modal.conteudo.endereco_aluno.endereco.bairro}}
								</div>
							</div>
							<br>
							<div class="row">
								<div class="col-md-4">
									<strong class="font-weight-bold">Logradouro:</strong><br>
									{{modal.conteudo.endereco_aluno.endereco.logradouro}}
								</div>
								<div class="col-md-4">
									<strong class="font-weight-bold">Número:</strong><br>
									{{modal.conteudo.endereco_aluno.numero}}
								</div>
								<div class="col-md-4">
									<strong class="font-weight-bold">CEP:</strong><br>
									{{ modal.conteudo.endereco_aluno.endereco.cep }}
								</div>
							</div>
							<br>
							<div class="row">
								<div class="col-md-12">
									<strong class="font-weight-bold">Complemento:</strong><br>
									{{modal.conteudo.endereco_aluno.complemento}}
								</div>
							</div>
						</div>
						<br>
					</div> -->

					<!-- <div slot="Anexos">
						<div class="row">
							<div class="col-md-12" v-for="documento in modal.conteudo.documentos" :key="documento.tipos_documentos.constante_tipo_documento_matricula">
								<span class="circle badge-success"></span>&nbsp;
								<button @click="getDocument(modal.conteudo.id_aluno)" type="button" class="btn btn-primary btn-micro">{{documento.tipos_documentos.tipo_documento_matricula}}</button><br>
							</div>
						</div>
					</div> -->

					<div slot="Financeiro">
						<div class="row">
							<div class="col-md-12">
								<table class="table table-responsive-sm">
									<thead>
										<tr>
											<th colspan="6">
												<span style="float:left;">Boletos</span>
											</th>
										</tr>
										<tr>
											<th>Processo</th>
											<th>Tipo</th>
											<th>Status</th>
											<th>Valor</th>
										</tr>
									</thead>
									<tbody v-if="typeof (modal.conteudo.faturas) != 'undefined' && modal.conteudo.faturas.length > 0">
										<tr v-for="fatura in modal.conteudo.faturas" :key="fatura.id">
											<td>{{ fatura.codigo_processo }}</td>
											<td>{{ fatura.tipo }}</td>
											<td>{{ fatura.status }}</td>
											<td>{{ fatura.valor | money }}</td>
                                        </tr>
									</tbody>
									<tbody v-else>
										<tr>
											<td colspan="6">Não Possui Faturas</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
						<div class="row">
							<div v-for="taxa in modal.conteudo.taxas" :key="taxa.id_alunos_taxas_valores" class="col-md-6">
								<strong class="font-weight-bold">{{ taxa.taxa_valor.taxa.taxa }}:</strong><br>
								<span class="circle badge-success" v-if="taxa.pago"></span>
								<span class="circle badge-danger" v-if="!taxa.pago"></span>
								R$ {{ taxa.taxa_valor.valor }}
							</div>
						</div>
						<br>
						<!--div class="row">
							<div class="col-md-12" style="text-align: center">
								<button class="btn btn-primary" @click="gerarBoleto(modal.conteudo.id_aluno)">Gerar Boleto</button>
							</div>
						</div-->
						<br>
					</div>

					<!--div slot="Etapas">
						<div v-if="modal.conteudo.etapa">
							<div class="row">
								<div class="col-md-2 text-right">
									<span class="badge badge-primary">Etapa {{ modal.conteudo.etapa.etapa.id_etapa }}</span>
								</div>
								<div class="col-md-9 text-left">
									{{ modal.conteudo.etapa.etapa.titulo }}
									<span><i class="fa fa-check green"></i></span>
								</div>
							</div>
							<br>
							<div class="row">
								<div class="col-md-12 text-center">
									<span @click="updateEtapa(modal.conteudo.id_aluno, 2)" class="btn badge badge-danger">voltar etapa</span>
									&nbsp;
									<span @click="updateEtapa(modal.conteudo.id_aluno, 1)" class="btn badge badge-success">avançar etapa</span>
								</div>
							</div>
						</div>
					</div-->

					<div slot="Histórico">
						<div v-if="modal.conteudo.etapa" class="row">
							<div class="col-md-12 text-center">
								<strong class="font-weight-bold">Etapa:</strong><br>
								{{ modal.conteudo.etapa.etapa.titulo }}
							</div>
						</div>
						<br><br>

						<div class="col-md-3">
							<button @click="showData()" id="button" class="btn btn-micro btn-secondary"
								style="margin-left: 20px; margin-top: -70px;"><i class="fa fa-search"></i> Dados</button>
						</div>

						<div class="row" v-if="modal.conteudo != {}">
							<span class="col-12 text-center font-weight-bold py-2">Resumo das aulas</span>

							<table class="table table-responsive-sm">
								<thead>
									<tr>
										<th>Diciplina</th>
										<th>Horas Exigidas</th>
										<th>Horas Cumpridas</th>
										<th>Horas Necessárias</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>{{ horasAula.direcaoDefensiva.label }}</td>
										<td>{{ horasAula.direcaoDefensiva.exigidas }}</td>
										<td>{{ horasAula.direcaoDefensiva.cumpridas }}</td>
										<td>{{ horasAula.direcaoDefensiva.necessarias }}</td>
									</tr>
									<tr>
										<td>{{ horasAula.legislacao.label }}</td>
										<td>{{ horasAula.legislacao.exigidas }}</td>
										<td>{{ horasAula.legislacao.cumpridas }}</td>
										<td>{{ horasAula.legislacao.necessarias }}</td>
									</tr>
									<tr>
										<td>{{ horasAula.mecanica.label }}</td>
										<td>{{ horasAula.mecanica.exigidas }}</td>
										<td>{{ horasAula.mecanica.cumpridas }}</td>
										<td>{{ horasAula.mecanica.necessarias }}</td>
									</tr>
									<tr>
										<td>{{ horasAula.meioAmbiente.label }}</td>
										<td>{{ horasAula.meioAmbiente.exigidas }}</td>
										<td>{{ horasAula.meioAmbiente.cumpridas }}</td>
										<td>{{ horasAula.meioAmbiente.necessarias }}</td>
									</tr>
									<tr>
										<td>{{ horasAula.primeirosSocorros.label }}</td>
										<td>{{ horasAula.primeirosSocorros.exigidas }}</td>
										<td>{{ horasAula.primeirosSocorros.cumpridas }}</td>
										<td>{{ horasAula.primeirosSocorros.necessarias }}</td>
									</tr>
								</tbody>
							</table>
						</div>

						<div class="row" v-if="modal.conteudo != {}">
							<span class="col-12 text-center font-weight-bold py-2">Aulas de Reposição</span>

							<table class="table table-responsive-sm">
								<thead>
									<tr>
										<th @click="sort('name')">Matéria</th>
										<th @click="sort('turma')">Turma</th>
										<td @click="sort('')">Status da Aula</td>
										<th>Inicio</th>
										<th>Fim</th>
										<th>Presença</th>
										<th>Fotos</th>
									</tr>
								</thead>
								<tbody v-for="turma in modal.conteudo.reposicoes" :key="turma.id_turma_teorica">
									<tr>
										<td>{{ turma.aula.materia.titulo }}</td>
										<td>{{ turma.aula.turma.titulo }}</td>
										<td>{{ statusAluno(turma.aula.id_turma_teorica) }}</td>
										<td>{{ utils.formatDate(turma.aula.inicio) }}</td>
										<td>{{ utils.formatDate(turma.aula.fim) }}</td>
										<td>
											<span v-if="presencaAluno(turma.aula.id_turma_teorica)">Presença</span>
											<span
												v-else-if="diaDaAulaPassou(turma.aula.inicio) && !presencaAluno(turma.aula.id_turma_teorica)">Falta</span>
											<span v-else-if="diaDaAulaNaoRealizada(turma.aula.inicio)">Não Realizada</span>
											<span v-else>-</span>
										</td>
										<td>
											<button v-if="presencaAluno(turma.aula.id_turma_teorica)" title="Visualizar Foto"
												class="btn btn-primary btn-with-icon rounded-icon btn-micro" @click="openModalReposicao(turma)">
												<span aria-hidden="true" class="fa fa-picture-o"
													style="font-size: 20px; padding-left: 3px"></span>
											</button>
											<p v-else>-</p>
										</td>
									</tr>
								</tbody>
								<tbody v-if="typeof (modal.conteudo.reposicoes) != 'undefined' && modal.conteudo.reposicoes.length === 0">
									<tr>
										<td colspan="8">Aluno não possui aulas de reposição</td>
									</tr>
								</tbody>
							</table>
						</div>

						<div class="row" v-if="modal.conteudo != {}">
							<span class="col-12 text-center font-weight-bold py-2">Aulas Teóricas</span>

							<table class="table table-responsive-sm">
								<thead>
									<tr>
										<th>Matéria</th>
										<th>Turma</th>
										<td>Status da Turma</td>
										<th>Inicio</th>
										<th>Fim</th>
										<th>Presença</th>
										<th>Fotos</th>
									</tr>
								</thead>
								<tbody v-for="turma in modal.conteudo.turmas" :key="turma.id_turma">
									<tr v-for="aula in turma.turma.aulas" :key="aula.id_aula_teorica">
										<td>{{ aula.materia.titulo }}</td>
										<td>{{ aula.materia.titulo }}</td>
										<td>{{ turma.turma.titulo }}</td>
										<td>{{ statusAluno(turma.id_turma_teorica) }}</td>
										<td>{{ utils.formatDate(aula.inicio) }}</td>
										<td>{{ utils.formatDate(aula.fim) }}</td>
										<td>
											<span v-if="presencaAluno(turma.id_turma_teorica)">Presença</span>
											<span v-else-if="diaDaAulaPassou(aula.inicio) &&
												!presencaAluno(turma.id_turma_teorica)">Falta</span>
											<span v-else-if="diaDaAulaNaoRealizada(aula.inicio)">Não Realizada</span>
											<span v-else>-</span>
										</td>
										<td>
											<button v-if="presencaAluno(turma.id_turma_teorica)" title="Visualizar Foto"
												class="btn btn-primary btn-with-icon rounded-icon btn-micro" @click="openModalTeorica(turma)">
												<span aria-hidden="true" class="fa fa-picture-o"
													style="font-size: 20px; padding-left: 3px"></span>
											</button>
											<p v-else>-</p>
										</td>
									</tr>
								</tbody>
								<tbody v-if="typeof (modal.conteudo.turmas) != 'undefined' && modal.conteudo.turmas.length === 0">
									<tr>
										<td colspan="8">Aluno não possui Aulas Teoricas</td>
									</tr>
								</tbody>
							</table>
						</div>

						<div class="row" v-if="modal.conteudo != {}">
							<table class="table table-responsive-sm">
								<thead>
									<th class="text-center" colspan="6">Aulas Praticas</th>
									<tr>
										<th>Turno</th>
										<th>Veiculo</th>
										<th>Status da Aula</th>
										<th>Data</th>
										<th>Presença</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="aula in modal.conteudo.aulas" :key="aula.id_aulas_praticas">
										<td>{{ aula.tipo_aula }}</td>
										<td>{{ aula.veiculo.placa }}</td>
										<td v-if="aula.status != null"> {{ aula.status }} </td>
										<td v-else-if="aula.id_anotacao_pratica == null"> Aula não realizada. </td>
										<td v-else-if="aula.processada == false"> Aguardando processamento. </td>
										<td v-else-if="aula.processada == true"> Aula processada. </td>
										<td v-else> - </td>
										<td>{{ utils.formatDate(aula.data_aula) }}</td>
										<td>
											<span v-if="aula.id_anotacao_pratica">Presença</span>
											<span v-else-if="!aula.id_anotacao_pratica && diaDaAulaPassou(aula.data_aula)">Falta</span>
											<span v-else-if="diaDaAulaNaoRealizada(aula.data_aula)">Não Realizada</span>
											<span v-else>-</span>
										</td>
									</tr>
								</tbody>
								<tbody v-if="typeof (modal.conteudo.aulas) != 'undefined' && modal.conteudo.aulas.length === 0">
									<tr>
										<td colspan="8">Aluno não possui Aulas de Praticas</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</vuestic-tabs>
			</div>
		</vuestic-modal>

		<vuestic-modal ref="presencareposicao" :cancelClass="'none'" :okClass="'none'">
			<div slot="title">Presença Aluno</div>
			<table>
				<thead>
					<tr>
						<th>FOTO</th>
						<th>TIPO</th>
						<th>HORÁRIO</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="presenca in modalPresencasReposicao">
						<td>
							<img width="100" :src="'data:image/jpg;base64, ' + presenca.foto" alt="Foto">
						</td>
						<td v-show="presenca.tipo == 0">Entrada</td>
						<td v-show="presenca.tipo == 1">Saída</td>
						<td v-show="presenca.tipo == 2">Intervalo</td>
						<td v-show="presenca.tipo.length > 1">{{ presenca.tipo }}</td>
						<td>{{ presenca.created_at }}</td>
					</tr>
				</tbody>
			</table>
			<br><br>
			<div class="col-md-12">
				<header>
					<h5>FOTOS AULAS TEÓRICAS</h5>
					<hr>
				</header>
				<div class="row">
					<div class="col-md-4" v-for="foto in modalFotosReposicao">
						<img width="100" :src="'data:image/jpg;base64, ' + foto.foto" alt="Foto">
					</div>
				</div>
			</div>
		</vuestic-modal>

		<vuestic-modal ref="presenca" :cancelClass="'none'" :okClass="'none'">
			<div slot="title">Presença Aluno</div>
			<table>
				<thead>
					<tr>
						<th>FOTO</th>
						<th>TIPO</th>
						<th>HORÁRIO</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="presenca in modalPresencas">
						<td>
							<img width="100" :src="'data:image/jpg;base64, ' + presenca.foto" alt="Foto">
						</td>
						<td v-show="presenca.tipo == 0">Entrada</td>
						<td v-show="presenca.tipo == 1">Saída</td>
						<td v-show="presenca.tipo == 2">Intervalo</td>
						<td v-show="presenca.tipo.length > 1">{{ presenca.tipo }}</td>
						<td>{{ presenca.created_at }}</td>
					</tr>
				</tbody>
			</table>
			<br><br>
			<div class="col-md-12">
				<header>
					<h5>FOTOS AULAS TEÓRICAS</h5>
					<hr>
				</header>
				<div class="row">
					<div class="col-md-4" v-for="foto in modalFotos">
						<img width="100" :src="'data:image/jpg;base64, ' + foto.foto" alt="Foto">
					</div>
				</div>
			</div>
		</vuestic-modal>

		<!--Botões da paginação-->

		<vuestic-modal :show.sync="modal.show" ref="fileModal" v-bind:small="false" cancelClass="none" okClass="none">
			<vuestic-tabs :names="['Filtro']" ref="tabs">
				<div slot="Filtro">
					<div class="row">
						<div class="col-md-6">
							<DateIconGroup idInput="data_ini" iconInput="fa-calendar" labelInput="Data Inicial">(AAAA-MM-DD)
							</DateIconGroup>
						</div>
						<div class="col-md-6">
							<DateIconGroup idInput="data_end" iconInput="fa-calendar" labelInput="Data Final">(AAAA-MM-DD)
							</DateIconGroup>
						</div>
					</div>
					<div class="row justify-content-center">
						<button class="btn btn-primary" @click="getfile">Download {{ this.fileExt }}</button>
					</div>
				</div>
			</vuestic-tabs>
		</vuestic-modal>

		<!--Legenda com barra de pesquisa-->
		<div class="row">
			<div class="col-md-12">
				<span class="circle badge-success"></span> {{ totalAlunos }} Ativos &nbsp;&nbsp;
				<span class="circle badge-danger"></span> Inativos &nbsp;&nbsp;&nbsp;&nbsp;
				<i alt="Download PDF" @click="openModal('alunos', 'pdf')" id="downloadButton" class="fa fa-file-pdf-o">
					<span class="tooltiptext">Download PDF</span>
				</i>&nbsp;&nbsp;
				<i @click="openModal('alunos', 'xlsx')" id="downloadButton" class="fa fa-file-excel-o">
					<span class="tooltiptext">Download XLSX</span>
				</i>&nbsp;&nbsp;
				<i @click="openModal('alunos', 'txt')" id="downloadButton" class="fa fa-file-text-o">
					<span class="tooltiptext  ">Download TXT</span>
				</i>
			</div>
			<!--div class="col-md-3">
				<fieldset>
					<div class="form-group with-icon-left">
						<div class="input-group">
							<input @input="debounceInput" id="search" autocomplete="off" required>
							<label class="control-label" for="search">Procurar...</label><i class="bar"></i>
							<i class="fa icon-left input-icon fa-search"></i>
						</div>
					</div>
				</fieldset>
			</div-->

			<!-- Filtro de Busca -->
			<!-- <div class="col-md-3" @keyup.enter="$refs.nome.$el.children[0].children[0].focus()">
				<InputIconGroup iconInput="fa-user-o" ref="id_aluno" idInput="id_aluno" labelInput="ID">
				</InputIconGroup>
			</div> -->
			<div class="col-md-3" @keyup.enter="$refs.cpf.$el.children[0].children[0].focus()">
				<InputIconGroup iconInput="fa-user" idInput="nome_aluno" ref="nome" labelInput="Nome do Aluno">
				</InputIconGroup>
			</div>
			<div class="col-md-3" @keyup.enter="$refs.renach.$el.children[0].children[0].focus()">
				<InputIconGroup typeInput="text" idInput="aluno_cpf" ref="cpf" iconInput="fa-id-card" labelInput="CPF"
					:inputMask="['###.###.###-##']">
					000.000.000-00&nbsp;
				</InputIconGroup>
			</div>
			<div class="col-md-3" @keyup.enter="$refs.datainicio.$el.children[0].children[0].focus()">
				<InputIconGroup iconInput="fa-address-card" idInput="renach_aluno" ref="renach" labelInput="Renach">
				</InputIconGroup>
			</div>
			<div class="col-md-3" @keyup.enter="$refs.processo.$el.children[0].focus()">
				<DateIconGroup idInput="ini_processo" iconInput="fa-calendar" ref="datainicio" labelInput="Início do Processo">
				</DateIconGroup>
			</div>
			<!-- <div class="col-md-3" ref="processo">
				<model-select :options="codigosProcesso" v-model="getProcesso" placeholder="Tipo de Processo"></model-select>
			</div> -->
			<!-- Filtro de Busca -->
		</div>
		<div class="row">
			<div class="col-md-12 mb-3 d-flex justify-content-center">
				<button @click="searchAlunos()" id="button" class="btn btn-micro btn-info button">
					<i class="fa fa-search"></i>
					<span class="font-button-modified">Consultar</span>
				</button>
			</div>
		</div>
		<!--Legenda com barra de pesquisa-->

		<!--Botões da paginação-->
		<div class="row" v-if="consulted">
			<div class="col mx-auto">
				<pagination :source="pagination" @navigate="navigate" class="pagination justify-content-center"></pagination>
			</div>
		</div>
		<!--Botões da paginação-->

		<!--Tabela-->
		<div class="row" v-if="consulted">
			<div class="col-md-12">
				<table class="table table table-striped table-bordered table-responsive-sm text-center tabela">
					<thead>
						<tr>
							<th v-for="th in tableOptions.thead" scope="col" :key="th.id">
								<span class="coluna" @click="ordenar(th, $event)">
									{{ th }}
									<span class="seta-cima" v-show="hover === 'asc' + th" v-bind:id="'asc' + th"></span>
									<span class="seta-baixo" v-show="hover === 'desc' + th" v-bind:id="'desc' + th"></span>
								</span>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-show="table.load">
							<td colspan="7" class="text-center">
								<div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
									<div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
										<component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80"></component>
									</div>
								</div>
							</td>
						</tr>
						<tr v-if="table.data.length < 1" v-show="!table.load">
							<td colspan="7">Sem resultados!</td>
						</tr>
						<tr v-else v-show="!table.load" v-for="dados in table.data" class="tb-linha" :key="dados.id">
							<td>
								<span class="circle badge-success" v-if="dados.flg_ativo"></span>
								<span class="circle badge-danger" v-if="!dados.flg_ativo"></span>
							</td>
							<td>{{ dados.nome }}</td>
							<td>{{ dados.cpf }}</td>
							<!-- <td id="renach">{{dados.renach}}</td> -->
							<td v-if="dados.created_at == null">-</td>
							<td v-else>{{ utils.formatDate(dados.created_at) }}</td>
							<td class="td-button">
								<button title="Desativar aluno" class="action-button" v-if="dados.flg_ativo" @click="atualizaStatus(dados.id_aluno, 'desativar')">
									<i class="fa fa-lock"></i>
								</button>

								<button title="Ativar aluno" class="action-button" v-if="!dados.flg_ativo" @click="atualizaStatus(dados.id_aluno, 'ativar')">
									<i class="fa fa-unlock"></i>
								</button>

								<button title="Ver informações do aluno" class="action-button" @click="detalhes(dados.id_aluno)" v-if="dados.categoria">
									<i class="fa fa-info"></i>
								</button>
								<!-- <button title="Editar aluno" class="btn btn-primary btn-with-icon rounded-icon btn-micro text-white botao" v-if="dados.tipo_processo == 999 " :disabled="!dados.flg_ativo" @click="paginaEdit(dados.id_aluno)">
									<span aria-hidden="true" class="fa fa-edit" style="font-size: 16px;"></span>
								</button>
								<button title="Editar aluno" class="btn btn-primary btn-with-icon rounded-icon btn-micro text-white botao" v-else :disabled="!dados.flg_ativo" @click="paginaEdicao(dados.id_aluno)">
									<span aria-hidden="true" class="fa fa-edit" style="font-size: 16px;"></span>
								</button> -->
								<button title="Atualizar aluno"	class="action-button" :disabled="!dados.flg_ativo" @click="atualizarAluno(dados.id_aluno)">
									<i class="fa fa-cloud-download"></i>
								</button>
							</td>
						</tr>
						<tr v-show="table.tp === 0 && !table.load">
							<td colspan="12" class="text-center">Nenhum registro encontrado.</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<!--Botões da paginação-->
		<div class="row" v-if="consulted">
			<div class="col mx-auto">
				<pagination :source="pagination" @navigate="navigate" class="pagination justify-content-center"></pagination>
			</div>
		</div>
		<!--Botões da paginação-->

		<!--Tabela-->
	</div>
</template>

<script>
import SelectIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/SelectIconGroup'
import { ModelSelect } from 'vue-search-select'
import FaturasController from '../faturas/FaturasController'
import InputIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/InputIconGroup'
import AlunosController from './AlunosController'
import * as spinners from 'epic-spinners'
import urlApi from '../../router/urlApi'
import DateIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/DateIconGroup'
import utils from '../../services/utils'
import pagination from '../pagination/pagination'
import _ from 'lodash'

window._ = require('lodash')

export default {
	name: 'TableAlunos',
	components: {
		...spinners,
		DateIconGroup,
		InputIconGroup,
		SelectIconGroup,
		ModelSelect,
		pagination
	},
	data() {
		return {
			loadboleto: false,
			modal: {
				id_aluno: '',
				show: false,
				load: false,
				conteudo: [],
			},
			horasAula: {
				direcaoDefensiva: {
					label: 'Direção Defensiva',
					exigidas: 16,
					cumpridas: 0,
					necessarias: 16,
				},
				legislacao: {
					label: 'Legislação',
					exigidas: 18,
					cumpridas: 0,
					necessarias: 18,
				},
				mecanica: {
					label: 'Mecânica',
					exigidas: 3,
					cumpridas: 0,
					necessarias: 3,
				},
				meioAmbiente: {
					label: 'Meio Ambiente e Convívio Social',
					exigidas: 4,
					cumpridas: 0,
					necessarias: 4,
				},
				primeirosSocorros: {
					label: 'Primeiros Socorros',
					exigidas: 4,
					cumpridas: 0,
					necessarias: 4,
				},
			},
			modalFotos: '',
			modalFotosReposicao: '',
			modalPresencas: '',
			modalPresencasReposicao: '',
			url: urlApi + '/alunos/ordenar',
			urlModal: urlApi + '/alunos/ordenar/Modal',
			tableOptions: { 'thead': ['#', 'Nome', 'CPF', 'Inicio do Processo', 'Ações'] },
			tableOptionsRep: { 'thead': ['Materia', 'Turma', 'Status da Aula', 'Inicio', 'Fim', 'Presença'] },
			search: '',
			table: {
				currentPage: '',
				data: '',
				firstPageUrl: '',
				from: '',
				lastPage: '',
				lastPageUrl: '',
				nextPageUrl: '',
				path: '',
				perPage: '',
				prevPageUrl: '',
				to: '',
				total: '',
				pages: [],
				load: false,
				tp: ''
			},
			pagination: '',
			utils: utils,
			fileExt: '',
			planos: '',
			selecionado: '',
			ordem: '',
			hover: '',
			codigosProcesso: [],
			getProcesso: '',
			totalAlunos: 0,
			courrentSort: 'titulo',
			currentSortDir: 'asc',
			consulted: false,
		}
	},
	mounted() {
		let self = this
		// self.loadData()
		self.$http.get(urlApi + '/planos/praticos').then(function (response) {
			self.planos = response.data.dados
		})

		this.$http.get(urlApi + '/alunos/quantidade').then(function (quantidade) {
			this.totalAlunos = quantidade.data.dados
		})

		this.$refs.id_aluno.$el.children[0].children[0].focus()
	},
	async detalhes (idAluno) {
		this.$refs.smallModal.open()
		this.modal.load = true

		await this.$http.get(`${urlApi}/alunos/${idAluno}`)
			.then(async (response) => {
				this.modal.conteudo = response.body.dados

				await this.$http.get(`${urlApi}/aulas/praticas/aluno/${idAluno}`)
					.then((response) => {
						response.body.dados.forEach(pratica => {
							this.planos.forEach((plano, index) => {
								if (pratica.anotacao) {
                	if (pratica.anotacao.edu_content == plano.constante) {
										if (!self.planos[index].numero) {
											self.planos[index].numero = 1
										} else {
											self.planos[index].numero += 1
										}
									}
								}
							})
						})

						this.modal.load = false
					})
					.catch((err) => {
						this.modal.load = false

						this.$toasted.show(err.body.dados, {
							position: 'top-right',
						});
					})
			})
			.catch((err) => {
				this.$refs.smallModal.close()

				this.modal.load = false

				this.$toasted.show(err.body.dados, {
          position: 'top-right',
        });
			})
	},

    // detalhes: function (idAluno) {
    //   let self = this
    //   this.$refs.smallModal.open()
    //   self.modal.load = true
    //   AlunosController.getAlunoById(idAluno, function (response) {
    //     self.modal.conteudo = response.data.dados

    //     self.$http.get(urlApi + `/aulas/praticas/aluno/${idAluno}`).then(function (response) {
    //       response.data.dados.forEach(pratica => {
    //         self.planos.forEach((plano, index) => {
    //           if (pratica.anotacao) {
    //             if (pratica.anotacao.edu_content == plano.constante) {
    //               if (!self.planos[index].numero) {
    //                 self.planos[index].numero = 1
    //               } else {
    //                 self.planos[index].numero += 1
    //               }
    //             }
    //           }
    //         })
    //       })
    //       self.modal.load = false

    //       // self.modal.conteudo.praticas.forEach(function(pratica, index){
    //       //   if(pratica.anotacao){
    //       //     if(pratica.anotacao.edu_content){
    //       //         self.$http.get(urlApi + `/planos/praticos/${pratica.anotacao.edu_content}`).then(function(response){
    //       //             self.modal.conteudo.praticas[index].anotacao.edu_content = response.data
    //       //             self.modal.load = false
    //       //         })
    //       //     } else {
    //       //         pratica.anotacao.edu_content = '-'
    //       //     }
    //       //   }
    //       // });
    //     })
    //     console.log(response)
    //   })
    // },

	paginaEdit(idAluno){
		AlunosController.paginaEdit(idAluno)
	},
	methods: {
 
		navigate(page) {
			this.table.load = true
			this.$http.get(`${this.table.path}?page=${page}`).then(this.callbackDataPaginate)
		},

		searchAlunos() {
            if( !(document.querySelector('#nome_aluno').value || document.querySelector('#aluno_cpf').value) )
            {
				AlunosController.launchToast('fa-times', 'Obrigatório informar Nome ou CPF', 'top-right')
                document.querySelector('#nome_aluno').focus()
                return
            }
			this.consulted = true
			this.table.load = true
			// var id = document.querySelector('#id_aluno').value ? document.querySelector('#id_aluno').value : 'null'
			const id = null
			var nome = document.querySelector('#nome_aluno').value ? document.querySelector('#nome_aluno').value : 'null'
			var cpf = document.querySelector('#aluno_cpf').value ? document.querySelector('#aluno_cpf').value : 'null'
			var renach = document.querySelector('#renach_aluno').value ? document.querySelector('#renach_aluno').value : 'null'
			var data = document.querySelector('#ini_processo').value ? document.querySelector('#ini_processo').value : 'null'
			var processo = this.getProcesso ? this.getProcesso : 'null'

			const url = `${urlApi}/alunos/buscar/${id}/${nome}/${cpf}/${renach}/${data}/${processo}`
			this.$http.get(url).then(this.callbackDataPaginate)
		},
		situacaoAluno(idAluno) {
			AlunosController.situacaoAluno(idAluno)
		},
		gerarBoleto(idAluno) {
			AlunosController.gerarBoleto(idAluno)
		},
		callbackDataPaginate(response) {
			let responseData = response.data

			if (response.data.alunos) {
				responseData = response.data.alunos
			} else {
				responseData = response.data
			}

			this.table.currentPage = responseData.current_page
			this.table.data = responseData.data
			this.table.firstPageUrl = responseData.first_page_url
			this.table.from = responseData.from
			this.table.lastPage = responseData.last_page
			this.table.lastPageUrl = responseData.last_page_url
			this.table.nextPageUrl = responseData.next_page_url
			this.table.path = responseData.path
			this.table.perPage = responseData.per_page
			this.table.prevPageUrl = responseData.prev_page_url
			this.table.to = responseData.to
			this.table.total = responseData.total
			this.table.pages = []
			for (let i = 1; i <= (responseData.last_page); i++) {
				this.table.pages.push(i)
			}
			this.items = this.table.data

			this.table.load = false

			this.pagination = responseData
            console.log(this.pagination)

			this.tp = responseData.data.length
		},
		nextPage() {
			this.table.load = true
			this.$http.get(this.table.nextPageUrl + '&search=' + this.search).then(this.callbackDataPaginate)
		},
		previousPage() {
			this.table.load = true
			this.$http.get(this.table.prevPageUrl + '&search=' + this.search).then(this.callbackDataPaginate)
		},
		pagePaginate(page) {
			this.table.load = true
			this.$http.get(this.table.path + '?page=' + page + '&search=' + this.search).then(this.callbackDataPaginate)
		},
		loadData() {
			this.table.load = true
			this.$http.get(this.url + '?search=' + this.search).then(this.callbackDataPaginate)
		},
		loadDataOrder(campo, ordenacao) {
			this.table.load = true
			this.$http.get(this.url + '?ordem=' + this.ordem + '&nome=' + this.selecionado + '&search=' + this.search).then(this.callbackDataPaginate)
		},

		debounceInput: _.debounce(function (e) {
			this.search = e.target.value
			this.loadData()
		}, 1000),

		atualizarAluno(idAluno) {
			let self = this
			self.$http.get(urlApi + `/getran/atualizar/aluno/${idAluno}`).then(function (response) {
				if (response.data.sucesso) {
					self.loadData()
				}
			}).catch(function (error) {
				AlunosController.launchToast('fa-times', error.data.dados, 'top-center')
			})
		},

		openModalReposicao(turma_reposicao) {
			this.$http.get(urlApi + '/alunos/detalhes-presencas/' + turma_reposicao.id_aluno + '/' + turma_reposicao.aula.id_turma_teorica + '/ALUNO/' + turma_reposicao.aula.virtual)
				.then((response) => {
					this.modalFotosReposicao = response.body.dados.fotos_teoricas
					this.modalPresencasReposicao = response.body.dados.presencas
					this.$refs.presencareposicao.open()
				})
		},

		openModalTeorica(turma_teorica) {
			this.$http.get(urlApi + '/alunos/detalhes-presencas/' + turma_teorica.id_aluno + '/' + turma_teorica.id_turma_teorica + '/ALUNO/' + turma_teorica.virtual)
				.then((response) => {
					this.modalFotos = response.body.dados.fotos_teoricas
					this.modalPresencas = response.body.dados.presencas
					this.$refs.presenca.open()
				})

			// this.$refs.presenca.open()
		},

		detalhes: function (idAluno) {
			let self = this
			this.$refs.smallModal.open()
			self.modal.load = true
			AlunosController.getAlunoById(idAluno, function (response) {
				self.modal.conteudo = response.data.dados

				self.horasAula = {
					direcaoDefensiva: {
						...self.horasAula.direcaoDefensiva,
						cumpridas: 0,
						necessarias: 16,
					},
					legislacao: {
						...self.horasAula.legislacao,
						cumpridas: 0,
						necessarias: 18,
					},
					mecanica: {
						...self.horasAula.mecanica,
						cumpridas: 0,
						necessarias: 3,
					},
					meioAmbiente: {
						...self.horasAula.meioAmbiente,
						cumpridas: 0,
						necessarias: 4,
					},
					primeirosSocorros: {
						...self.horasAula.primeirosSocorros,
						cumpridas: 0,
						necessarias: 4,
					},
				}

				self.setResumoAulas(response.data.dados.turmas)
				self.setResumoAulas(response.data.dados.reposicoes)

				self.$http.get(urlApi + `/aulas/praticas/aluno/${idAluno}`).then(function (response) {
					response.data.dados.forEach(pratica => {
						self.planos.forEach((plano, index) => {
							if (pratica.anotacao) {
								if (pratica.anotacao.edu_content == plano.constante) {
									if (!self.planos[index].numero) {
										self.planos[index].numero = 1
									} else {
										self.planos[index].numero += 1
									}
								}
							}
						})
					})
					self.modal.load = false

					// self.modal.conteudo.praticas.forEach(function(pratica, index){
					//   if(pratica.anotacao){
					//     if(pratica.anotacao.edu_content){
					//         self.$http.get(urlApi + `/planos/praticos/${pratica.anotacao.edu_content}`).then(function(response){
					//             self.modal.conteudo.praticas[index].anotacao.edu_content = response.data
					//             self.modal.load = false
					//         })
					//     } else {
					//         pratica.anotacao.edu_content = '-'
					//     }
					//   }
					// });
				})
			})
		},
		setResumoAulas(dados) {
			dados.forEach(turma => {
				// const presencaEncontrada = this.modal.conteudo.presencas.find(presenca => turma.id_turma_teorica === presenca.id_turma_teorica)

                if(typeof(turma.turma) == 'object') {
					turma.turma.aulas.map(aula => {
                        const status = this.statusAluno(aula.id_turma_teorica)
                        if(status == "CONFIRMADO") {
                            switch (aula.materia.id_materia) {
                                case 11: {
                                    this.horasAula.meioAmbiente.cumpridas = this.horasAula.meioAmbiente.cumpridas + 1
                                    this.horasAula.meioAmbiente.necessarias = Math.max(this.horasAula.meioAmbiente.necessarias - 1, 0)

                                    break
                                }
                                case 10: {
                                    this.horasAula.primeirosSocorros.cumpridas = this.horasAula.primeirosSocorros.cumpridas + 1
                                    this.horasAula.primeirosSocorros.necessarias = Math.max(this.horasAula.primeirosSocorros.necessarias - 1, 0)

                                    break
                                }
                                case 9: {
                                    this.horasAula.mecanica.cumpridas = this.horasAula.mecanica.cumpridas + 1
                                    this.horasAula.mecanica.necessarias = Math.max(this.horasAula.mecanica.necessarias - 1, 0)

                                    break
                                }
                                case 7: {
                                    this.horasAula.direcaoDefensiva.cumpridas = this.horasAula.direcaoDefensiva.cumpridas + 1
                                    this.horasAula.direcaoDefensiva.necessarias = Math.max(this.horasAula.direcaoDefensiva.necessarias - 1, 0)

                                    break
                                }
                                case 6: {
                                    this.horasAula.legislacao.cumpridas = this.horasAula.legislacao.cumpridas + 1
                                    this.horasAula.legislacao.necessarias = Math.max(this.horasAula.legislacao.necessarias - 1, 0)

                                    break
                                }
                            }
                        }
					})
				}else if(typeof(turma) == 'object') {
                    const status = this.statusAluno(turma.aula.id_turma_teorica)
					if(status == "CONFIRMADO") {
						switch (turma.aula.materia.id_materia) {
							case 11: {
								this.horasAula.meioAmbiente.cumpridas = this.horasAula.meioAmbiente.cumpridas + 1
								this.horasAula.meioAmbiente.necessarias = Math.max(this.horasAula.meioAmbiente.necessarias - 1, 0)

								break
							}
							case 10: {
								this.horasAula.primeirosSocorros.cumpridas = this.horasAula.primeirosSocorros.cumpridas + 1
								this.horasAula.primeirosSocorros.necessarias = Math.max(this.horasAula.primeirosSocorros.necessarias - 1, 0)

								break
							}
							case 9: {
								this.horasAula.mecanica.cumpridas = this.horasAula.mecanica.cumpridas + 1
								this.horasAula.mecanica.necessarias = Math.max(this.horasAula.mecanica.necessarias - 1, 0)

								break
							}
							case 7: {
								this.horasAula.direcaoDefensiva.cumpridas = this.horasAula.direcaoDefensiva.cumpridas + 1
								this.horasAula.direcaoDefensiva.necessarias = Math.max(this.horasAula.direcaoDefensiva.necessarias - 1, 0)

								break
							}
							case 6: {
								this.horasAula.legislacao.cumpridas = this.horasAula.legislacao.cumpridas + 1
								this.horasAula.legislacao.necessarias = Math.max(this.horasAula.legislacao.necessarias - 1, 0)

								break
							}
						}
					}
				}
			})
		},
		atualizaStatus: function (idAluno, status) {
			let self = this
			AlunosController.atualizaStatus(idAluno, status, function () {
				self.loadData()
			})
		},

		paginaEdit(idAluno) {
			AlunosController.paginaEdit(idAluno)
		},

		paginaEdicao(idAluno) {
			AlunosController.paginaEdicao(idAluno)
		},

		updateEtapa(idAluno, action) {
			let self = this
			this.$http.get(urlApi + '/alunos/update_etapa/' + idAluno + '/' + action).then(function (response) {
				self.modal.conteudo.etapa.etapa = response.data.dados.etapa
				self.modal.conteudo.etapa = response.data.dados
				// AlunosController.launchToast('fa-check', response.data.mensagem, 'top-center');
			}).catch((response) => {
				AlunosController.launchToast('fa-times', response.data.dados, 'top-center')
			})
		},

		getDocument(idAluno) {
			this.$http.get(urlApi + '/alunos/documento/' + idAluno).then(function (response) {
				let w = window.open('')
				if (response.data.ext !== 'pdf') {
					let image = new Image()
					image.src = `data:image/${response.data.ext};base64, ${response.data.dados}`
					w.document.write(image.outerHTML)
				} else {
					w.document.write(`<object width='100%' height='100%' data='data:application/pdf;base64, ${response.data.dados}' type='application/pdf'></object>`)
				}
			})
		},

		openModal(entity, ext) {
			this.fileName = entity
			this.fileExt = ext
			this.$refs.fileModal.open()
		},

		getfile() {
			var ini = document.getElementById('data_ini').value
			var end = document.getElementById('data_end').value

			if (!ini || !end) {
				AlunosController.launchToast('fa-times', 'Ops! Preencha as datas corretamente!')
				return
			}

			if (this.fileExt === 'pdf') {
				utils.generatePDF(this.fileName, ini, end)
				this.$refs.fileModal.close()
			} else {
				utils.generateTXTorXLSX(this.fileName, this.fileExt, ini, end)
				this.$refs.fileModal.close()
			}
		},

		ordenar: function (campo, event) {
			if (campo === "Ações" || campo === "#") {
				return
			}

			var id = campo
			campo = campo.toLowerCase()
			campo = campo === 'inicio do processo' ? 'created_at' : campo

			if (campo === this.selecionado) {
				this.ordem = this.ordem === 'desc' ? 'asc' : 'desc'
				this.loadDataOrder()
			} else {
				this.selecionado = campo
				this.ordem = 'asc'
				this.loadDataOrder()
			}
			this.hover = document.getElementById(this.ordem + id).id
		},
		posicao(index) {
			let distancia = index - this.table.currentPage
			if (distancia > -3 && distancia < 1) {
				return true
			}
			return false
		},

		gerarFatura(boleto = null) {
			this.loadboleto = true
			let self = this
			var fatura = []
			if (boleto) {
				fatura.push(boleto)
			} else {
				this.modal.conteudo.boletos.forEach(element => {
					if (!element.cancelado) {
						fatura.push(element)
					}
				})
			}
			FaturasController.gerarBoletoTeorico(fatura).then(function (
				link
			) {
				window.open(link, '_blank')
				self.loadboleto = false
			}, erro => {
				self.loadboleto = false
			})
		},

		presencaAluno(idTurma) {
			let presencaEncontrada = this.modal.conteudo.presencas.find(presenca => {
				return idTurma === presenca.id_turma_teorica
			})
			if (presencaEncontrada == undefined) {
				return false
			} else {
				return true
			}
		},

		statusAluno(idTurma) {
			let presencaEncontrada = this.modal.conteudo.presencas.find(presenca => {
				return idTurma === presenca.id_turma_teorica
			})
			if (presencaEncontrada == undefined) {
				return '-'
			} else {
				return presencaEncontrada.status
			}
		},

		diaDaAulaPassou(aula) {
			if (new Date(aula) < new Date()) {
				return true
			} else {
				return false
			}
		},

		diaDaAulaNaoRealizada(aula) {
			if (new Date(aula) > new Date()) {
				return true
			} else {
				return false
			}
		},

		reset() {
			this.item = {}
		},
		selectFromParentComponent1() {
			this.item = this.options[0]
		},
		reset2() {
			this.item2 = ''
		},
		selectFromParentComponent2() {
			this.item2 = this.options2[0].value
		},
		sort(s) {
			// if s == current sort, reverse
			if (s === this.currentSort) {
				this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
			}
			this.currentSort = s
		},
		showData() {
			// console.log(JSON.stringify(this.modal.conteudo.reposicoes))
		}
	},
	filters: {
		money(value) {
			var resultado = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'BRL' }).format(value)
			return resultado
		},
	},
	computed: {
		sortedCats: function () {
			return this.cats.sort((a, b) => {
				let modifier = 1
				if (this.currentSortDir === 'desc') modifier = -1
				if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier
				if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier
				return 0
			})
		}
	}
}
</script>

<style type="scss" scoped>
	.td-button {
		display: flex;
		justify-content: center;
		gap: 0.25rem;
		flex-wrap: wrap;
	}

	.action-button {
    all: unset;
    cursor: pointer;

    &:disabled {
      opacity: 0.5;
      cursor: wait;
    }

		.fa {
			width: 35px;
			height: 35px;
			line-height: 15px;
			margin: 0px;
			color: white;
      padding: 10px;
      border-radius: 50%;
		}

		.fa-lock {
			background-color: #dc3545;
			border-color: #dc3545;
			box-shadow: black;
		}

		.fa-lock:hover {
			background-color: #dc354683;
		}

		.fa-unlock {
			background-color: #20c997;
			border-color: #20c997;
			box-shadow: black;
		}

		.fa-unlock:hover {
			background-color: #20c9967e;
		}

		.fa-info {
      background-color: #ffc20e;
      border-color: #ffc20e;
      box-shadow: black;
    }

		.fa-info:hover {
      background-color: #ffc30eaa;
    }

		.fa-cloud-download {
      background-color: #4ab2e3;
      border-color: #4ab2e3;
      box-shadow: black;
    }

		.fa-cloud-download:hover {
      background-color: #2c7da3;
    }
  }

.button {
	display: flex;
	align-items: center;
	gap: 1rem;
}

@media (max-width: 1316px) {
	.flex {
		display: flex;
	}

	.botao {
		margin-right: 15px;
	}
}

@media (max-width: 1200px) {
	.tb-opcoes {
		display: block;
	}

	#button {
		width: 150px;
	}

	.td-button {
		display: flex;
		margin-left: -21px;
	}

	.btn-micro {
		margin-left: 2px;
	}
}

@media (max-width: 820px) {
	#renach {
		display: none;
	}
}

@media (max-width: 768px) {
	.tb-opcoes {
		display: block;
	}

	#button {
		margin-bottom: 70px;
		margin-left: 77%;
		margin-bottom: 3%;
	}

	#renach {
		display: none;
	}
}

@media (max-width: 724px) {
	.tb-opcoes {
		display: block;
	}

	#button {
		margin-top: 10px;
		margin-left: 73%;
		margin-bottom: 4%;

	}
}

@media (max-width: 688px) {
	.tabela {
		width: 100%;
	}

	/* #renach {
			display: none;
		} */
	.botao {
		margin-right: 5px;
	}

	.flex {
		display: flex;
	}
}

@media (max-width: 650px) {
	.tb-opcoes {
		display: block;
	}

	#button {
		margin-top: 10px;
		margin-left: 73%;
	}
}

@media (max-width: 628px) {
	.tb-opcoes {
		display: block;
	}

	#button {
		margin-top: 10px;
		margin-left: 71%;
		margin-bottom: 5%;

	}
}

@media (max-width: 591px) {
	.tb-opcoes {
		display: block;
	}

	#button {
		margin-top: 10px;
		margin-left: 70%;
		margin-bottom: 5%;
	}

	.tabela {
		width: 100%;
	}
}

@media (max-width: 575px) {
	.tb-opcoes {
		display: block;
	}

	#button {
		margin-top: 10px;
		margin-left: 69%;
		margin-bottom: 5%;
	}

	.tabela {
		width: 100%;
	}
}

@media (max-width: 558px) {
	.tb-opcoes {
		display: block;
	}

	#button {
		margin-top: 10px;
		margin-left: 68%;
		margin-bottom: 5%;

	}
}

@media (max-width: 543px) {
	.tb-opcoes {
		display: block;
	}

	#button {
		margin-top: 10px;
		margin-left: 65%;
		margin-bottom: 5%;

	}
}

@media (max-width: 533px) {
	.tb-opcoes {
		display: block;
	}

	#button {
		margin-top: 10px;
		margin-left: 62%;
		margin-bottom: 5%;

	}
}

@media (max-width: 470px) {
	.tb-opcoes {
		display: block;
	}

	#button {
		margin-top: 10px;
		margin-left: 60%;
		margin-bottom: 5%;
	}
}

@media (max-width: 543px) {
	.tb-opcoes {
		display: block;
	}

	#button {
		margin-top: 10px;
		margin-left: 63%;
	}
}

@media (max-width: 481px) {
	.tb-opcoes {
		display: block;
	}

	#button {
		margin-top: 10px;
		margin-left: 61%;
	}
}

@media (max-width: 460px) {
	.tb-opcoes {
		display: block;
	}

	#button {
		margin-top: 10px;
		margin-left: 59%;
	}

	.tabela {
		width: 86%;
	}
}

@media (max-width: 442px) {
	.tb-opcoes {
		display: block;
	}

	#button {
		margin-top: 10px;
		margin-left: 57%;
	}
}

@media (max-width: 425px) {
	.tb-opcoes {
		display: block;
	}

	#button {
		margin-bottom: 40px;
		margin-left: 54%;
	}

	.dados {
		text-align: center;
	}

	.tabela {
		width: 97%;
		-webkit-width: 97%;
	}
}

@media (max-width: 404px) {
	.tb-opcoes {
		display: block;
	}

	#button {
		margin-top: 10px;
		margin-left: 50%;
	}
}

@media (max-width: 393px) {
	.tabela {
		width: 83%;
		-webkit-width: 83%;
	}
}

@media (max-width: 377px) {
	.tb-opcoes {
		display: block;
	}

	#button {
		margin-top: 10px;
		margin-left: 46%;
	}

	.tabela {
		width: 88%;
	}
}

@media (max-width: 355px) {
	.tb-opcoes {
		display: block;
	}

	#button {
		margin-top: 10px;
		margin-left: 41%;
	}
}

@media (max-width: 332px) {
	.tb-opcoes {
		display: block;
	}

	#button {
		margin-top: 10px;
		margin-left: 36%;
	}

	.tabela {
		width: 100%;
		-webkit-width: 100%;
	}
}

.coluna {
	cursor: pointer;
}

.filter {
	color: black !important;
}

.circle {
	width: .75rem;
	height: .75rem;
	border-radius: 50%;
	display: inline-block;
}

.green {
	color: rgb(19, 214, 19);
}

img {
	border: 1px solid #ddd;
	border-radius: 8px;
}

.seta-cima:before {
	content: "";
	display: inline-block;
	vertical-align: middle;
	margin: 0;
	width: 0;
	height: 0;

	border-left: 5px solid transparent;
	border-right: 5px solid transparent;
	border-bottom: 5px solid rgb(34, 143, 233);
}

.seta-baixo:before {
	content: "";
	display: inline-block;
	vertical-align: middle;
	margin: 0;
	width: 0;
	height: 0;

	border-left: 5px solid transparent;
	border-right: 5px solid transparent;
	border-top: 5px solid rgb(34, 143, 233);
}

td {
	width: auto;
}

.table td {
	padding: 1rem;
}

.botao {
	margin-right: 2px;
}</style>
